import axios from 'axios';
import { getProject } from '../gcloud/getProject';

export default async (workflowEditId, workflowPublishedId, httpRequest = axios, project = getProject()) => {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${Date.now()}`
  }

  const qry = `?oldId=${workflowEditId}&newId=${workflowPublishedId}`
  const url = `${project}/publishedWorkflowCopyV2${qry}`;

  return await httpRequest({
    url: url,
    method: 'GET',
    headers: config
  });
}